const items = [
  "EXCLUSIVE 10% OFF",
  "PREMIUM CURATION",
  "ELEVATE YOUR LIFESTYLE",
  "TRUSTED DROPS",
];

export const Marquee = () => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-white/10 py-10 md:py-14"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`font-display text-6xl font-extrabold tracking-tighter md:text-8xl ${
                i % 2 === 0 ? "text-white" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="mx-8 text-4xl text-[#ccff00] md:mx-12 md:text-6xl">
              ✦
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
